import { isWeb } from './utils.ts';

type Props = React.PropsWithChildren<{ wrapper: (c: React.ReactNode) => React.ReactNode }>;

export const WebOnlyWrapper = ({ wrapper, children }: Props) =>
  isWeb() ? wrapper(children) : children;
